module.exports = __webpack_public_path__ + "img/personal-laser-defense-equipment.3ccbddb8.png";